import {useEffect, useState} from 'react';

import {useContextHolder} from './context';

export const useContextRemaining = () => {
	const holder = useContextHolder();
	const [remaining, setRemaining] = useState<string>(holder.calcRemaining());

	// Since the holder expires value does not update
	// we do not mark this as an observer and instead
	// use an interval that updates the text string
	useEffect(() => {
		if (!holder.active) {
			setRemaining(holder.calcRemaining());
			return;
		}

		// Create interval that checks holder value; auto clearing
		const interval = setInterval(() => {
			if (holder.expires > 0) {
				const remaining = holder.calcRemaining();
				setRemaining(remaining);
				if (remaining === '00:00') {
					clearInterval(interval);
				}
			}
		}, 500);

		return () => clearInterval(interval);
	}, [holder, holder.active]);

	return remaining;
};
